exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: absolute;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  width: 100%;\n  background-color: #000000;\n  -ms-flex-flow: column;\n      flex-flow: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  overflow: hidden; }\n  :host .filler {\n    -ms-flex: 1 1 1px;\n        flex: 1 1 1px; }\n  :host .bet-button {\n    background-image: linear-gradient(to top, #f9b800, #ef8200);\n    -ms-flex: 1 0 50px;\n        flex: 1 0 50px;\n    max-height: 70px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    font-family: WickedMouse, Mikodacs;\n    font-size: 18px;\n    color: white; }\n    :host .bet-button img {\n      margin-right: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/game-view/game-view.component.scss
// module id = ../../../../../src/app/game-view/game-view.component.scss
// module chunks = 1